export default [
  {
    name: 'settings.main.dailyReservationsTitle',
    desc: 'settings.main.dailyReservationsDesc',
    setting: 'daily_reservations',
    url: '',
    isBeta: true,
    isIntegration: false
  },
  {
    name: 'settings.main.myPageTitle',
    desc: 'settings.main.myPageDesc',
    setting: 'my_page',
    url: '/settings/www',
    isIntegration: false
  },
  {
    name: 'settings.main.reservationParamsTitle',
    desc: 'settings.main.reservationParamsDesc',
    setting: 'reservation_parameters',
    url: '/reservation/parameters',
    isIntegration: false
  },
  {
    name: 'settings.main.smsTitle',
    desc: 'settings.main.smsDesc',
    setting: 'sms',
    url: '/settings/sms',
    isIntegration: false
  },
  {
    name: 'settings.main.paymentsTitle',
    desc: 'settings.main.paymentsDesc',
    setting: 'payment',
    url: '/settings/payments',
    isIntegration: false
  },
  {
    name: 'settings.main.workersTitle',
    desc: 'settings.main.workersDesc',
    setting: 'workers',
    url: '/workers',
    isIntegration: false
  },
  {
    name: 'settings.main.googleCalendarTitle',
    desc: 'settings.main.googleCalendarDesc',
    setting: 'google_calendar',
    url: '/settings/google-calendar',
    isIntegration: true
  },
  {
    name: 'settings.main.outlookCalendarTitle',
    desc: 'settings.main.outlookCalendarDesc',
    setting: 'outlook_calendar',
    url: '/settings/outlook-calendar',
    isIntegration: true
  },
  {
    name: 'settings.main.fakturowniaTitle',
    desc: 'settings.main.fakturowniaDesc',
    setting: 'fakturownia_api',
    url: '/settings/fakturownia',
    isIntegration: true
  },
  {
    name: 'settings.main.getResponseTitle',
    desc: 'settings.main.getResponseDesc',
    setting: 'getresponse',
    url: '/settings/getresponse',
    isIntegration: true
  },
  {
    name: 'settings.main.multilanguageTitle',
    desc: 'settings.main.multilanguageDesc',
    setting: 'multilang',
    url: '/settings/multilanguage',
    isIntegration: false
  }
];



// WEBPACK FOOTER //
// ./src/components/helpers/settings-list.js